import React from "react";

// component
import Header from 'components/Layout/Header';
import Footer from 'components/Layout/Footer';
import Helmet from 'components/Helmet/Helmet';


const Layout = ({children}) => {
	return (
		<>
			<Helmet>
				<meta charSet="utf-8"/>
				<meta name="description" content="産業遺産情報センターは、世界遺産「明治日本の産業革命遺産 製鉄・製鋼、造船、石炭産業」の インタープリテーション戦略（２０１７年１１月 ユネスコ世界遺産センターに提出）に基づき 「明治日本の産業革命遺産」の８県１１市に立地するビジターセンターの中核センターとして 各地と連携しインタープリテーション戦略を推進します。 なお、同センターは調査研究機関としての機能を有し、国内外の産業遺産並びに産業史の史料収集、 調査研究、広報活動、インタープリテーション、教育・研修、保全と活用、 ディジタル文書化などの事業を推進し、情報発信を行います。 調査・研究には産業労働や暮らしについての調査や発信が含まれます。 ２０２０年３月３１日に開設されましたが、新型コロナウイルスの感染拡大を防止するため 臨時休館しておりました。 緊急事態宣言の解除および東京都の活動再開のロードマップを踏まえ ２０２０年６月１５日より公開いたします。 新型コロナウイルスの感染拡大防止のための対策の一つとして 入場人数を制限し、当面、完全予約制といたします。 *** 予約に関するお知らせ (2020/6/25) 産業遺産情報センターにご関心をお寄せ下さり、誠にありがとうございます。 現在、新型コロナウイルス感染拡大防止のために完全予約制をとっており、6月、7月、8月の中旬まで 満席となったことから、一旦予約受付を中止させていただきます。 多くの方々の観覧のご希望に添えることができなく申し訳ありません。 受付再開のお知らせは、当ウェブサイトにてご案内申し上げます。 新型コロナウイルス感染拡大防止のために、完全予約システムを取り入れておりますこと 改めてご理解いただけますようお願い申し上げます。"/>
				<title>産業遺産情報センター：予約受付</title>
				<meta property="og:type" content="website"/>
				<meta property="og:image" content="https://image.jimcdn.com/app/cms/image/transf/none/path/sa1011a9e2c55e83c/backgroundarea/ice68b48c273e6538/version/1591156286/image.png"/>
				<meta property="og:url" content="https://www.ihic.jp"/>
				<meta property="og:site_name" content="産業遺産情報センター"/>
				<meta property="og:description" content="産業遺産情報センターは、世界遺産「明治日本の産業革命遺産 製鉄・製鋼、造船、石炭産業」の インタープリテーション戦略（２０１７年１１月 ユネスコ世界遺産センターに提出）に基づき 「明治日本の産業革命遺産」の８県１１市に立地するビジターセンターの中核センターとして 各地と連携しインタープリテーション戦略を推進します。 なお、同センターは調査研究機関としての機能を有し、国内外の産業遺産並びに産業史の史料収集、 調査研究、広報活動、インタープリテーション、教育・研修、保全と活用、 ディジタル文書化などの事業を推進し、情報発信を行います。 調査・研究には産業労働や暮らしについての調査や発信が含まれます。 ２０２０年３月３１日に開設されましたが、新型コロナウイルスの感染拡大を防止するため 臨時休館しておりました。 緊急事態宣言の解除および東京都の活動再開のロードマップを踏まえ ２０２０年６月１５日より公開いたします。 新型コロナウイルスの感染拡大防止のための対策の一つとして 入場人数を制限し、当面、完全予約制といたします。 *** 予約に関するお知らせ (2020/6/25) 産業遺産情報センターにご関心をお寄せ下さり、誠にありがとうございます。 現在、新型コロナウイルス感染拡大防止のために完全予約制をとっており、6月、7月、8月の中旬まで 満席となったことから、一旦予約受付を中止させていただきます。 多くの方々の観覧のご希望に添えることができなく申し訳ありません。 受付再開のお知らせは、当ウェブサイトにてご案内申し上げます。 新型コロナウイルス感染拡大防止のために、完全予約システムを取り入れておりますこと 改めてご理解いただけますようお願い申し上げます。"/>
			</Helmet>
			<Header />
			<main className="l-content">
				{ children }
			</main>
			<Footer />
		</>
	);
};

export default Layout;